/* eslint-disable */
/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable react/prop-types */
/* eslint-disable no-use-before-define */
/* eslint-disable no-unused-vars */
import React, { useEffect, useState } from 'react';
import {
    Table,
    TableBody,
    TableCell,
    TableHead,
    TableRow,
    Paper,
    Typography,
    Box,
    Fade,
    Chip,
    IconButton,
    Menu,
    MenuItem,
    CircularProgress,
    Tooltip,
    Tabs,
    Tab,
    TextField,
    InputAdornment,
    FormControl,
    InputLabel,
    Select,
    MenuItem as SelectMenuItem
} from '@mui/material';
import {
    NavigateNext,
    NavigateBefore,
    MoreVert as MoreVertIcon,
    Edit as EditIcon,
    Delete as DeleteIcon,
    Block as BlockIcon,
    List as ListIcon,
    Add as AddIcon,
    Search as SearchIcon,
    Clear as ClearIcon
} from '@mui/icons-material';
import { useJobTitle } from 'hooks/api/terminology/job-title/useJobTitle';
import Swal from 'sweetalert2';
import { PaginationButton, StyledTableContainer, globalColor } from '../../ConstantColors';
import { JobTitleForm } from './add';
import { logger } from 'utils/environment/log';
import {
    AuditCell,
    ClampedText,
    ConfigurationActionMenu,
    ConfigurationPagination,
    ConfigurationStatusChip,
    stickyActionCellSx,
    stickyActionHeadSx,
    tableSx
} from '../components/ConfigurationTable';

// Toast Configuration
const Toast = Swal.mixin({
    toast: true,
    position: 'top-end',
    showConfirmButton: false,
    timer: 3000,
    timerProgressBar: true
});

// Action Menu Component
const ActionMenu = ({ jobTitle, onEdit, onDelete, onToggleActive }) => {
    const [anchorEl, setAnchorEl] = useState(null);
    const open = Boolean(anchorEl);

    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };

    const handleAction = (action) => {
        handleClose();
        action();
    };

    return (
        <>
            <Tooltip title="Actions">
                <IconButton onClick={handleClick}>
                    <MoreVertIcon />
                </IconButton>
            </Tooltip>
            <Menu anchorEl={anchorEl} open={open} onClose={handleClose}>
                <MenuItem onClick={() => handleAction(onEdit)}>
                    <EditIcon sx={{ mr: 1 }} /> Edit
                </MenuItem>
            </Menu>
        </>
    );
};

// Search Component - NEW ADDITION
const SearchSection = ({ searchTerm, setSearchTerm, searchField, setSearchField, onClearSearch, loading }) => {
    const searchFields = [
        { value: 'title', label: 'Job Title Name' },
        { value: 'description', label: 'Description' },
        { value: 'createdByName', label: 'Created By' },
        { value: 'updatedByName', label: 'Modified By' }
    ];

    return (
        <Box sx={{ mb: 3, display: 'flex', gap: 2, alignItems: 'center', flexWrap: 'wrap' }}>
            <FormControl size="small" sx={{ minWidth: 150 }}>
                <InputLabel>Search Field</InputLabel>
                <Select value={searchField} label="Search Field" onChange={(e) => setSearchField(e.target.value)} disabled={loading}>
                    {searchFields.map((field) => (
                        <SelectMenuItem key={field.value} value={field.value}>
                            {field.label}
                        </SelectMenuItem>
                    ))}
                </Select>
            </FormControl>

            <TextField
                size="small"
                placeholder={`Search by ${searchFields.find((f) => f.value === searchField)?.label || 'JobTitle Name'}`}
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
                disabled={loading}
                sx={{ flexGrow: 1, maxWidth: 400 }}
                InputProps={{
                    startAdornment: (
                        <InputAdornment position="start">
                            <SearchIcon color="action" />
                        </InputAdornment>
                    ),
                    endAdornment: searchTerm && (
                        <InputAdornment position="end">
                            <IconButton size="small" onClick={onClearSearch} disabled={loading}>
                                <ClearIcon />
                            </IconButton>
                        </InputAdornment>
                    )
                }}
            />
        </Box>
    );
};

// Main JobTitle Component
const JobTitle = () => {
    const { listJobTitle, jobTitles, createJobTitle, deleteJobTitle, updateJobTitle, getJobTitleById } = useJobTitle();
    const [page, setPage] = useState(0);
    const [selectedJobTitle, setSelectedJobTitle] = useState(null);
    const [loading, setLoading] = useState(true);
    const [activeTab, setActiveTab] = useState(0);
    const [searchTerm, setSearchTerm] = useState('');
    const [searchField, setSearchField] = useState('title');
    const rowsPerPage = 5;

    useEffect(() => {
        fetchJobTitles();
    }, []);

    const getFilteredJobTitles = () => {
        if (!jobTitles || !Array.isArray(jobTitles)) {
            return [];
        }
        if (!searchTerm.trim()) {
            return jobTitles;
        }

        const searchLower = searchTerm.toLowerCase().trim();
        return jobTitles.filter((jobTitle) => {
            const fieldValue = jobTitle[searchField];
            if (fieldValue === null || fieldValue === undefined) {
                return false;
            }
            return String(fieldValue).toLowerCase().includes(searchLower);
        });
    };
    const filteredJobTitles = getFilteredJobTitles();

    const fetchJobTitles = async () => {
        setLoading(true);
        try {
            await listJobTitle(0, 1000);
        } catch (error) {
            Toast.fire({
                icon: 'error',
                title: 'Failed to fetch jobTitles'
            });
        } finally {
            setLoading(false);
        }
    };
    const handleClearSearch = () => {
        setSearchTerm('');
        setPage(0);
    };

    const handleSubmit = async (values, { resetForm, setSubmitting }) => {
        try {
            if (values.id && values.id !== 0) {
                const updateData = {
                    id: values.id,
                    title: values.title,
                    description: values.description,
                    isActive: values.isActive,
                    createdByName: values.createdByName,
                    updatedByName: values.updatedByName,
                    createdAt: values.createdAt,
                    updatedAt: new Date().toISOString()
                };
                await updateJobTitle(values.id, updateData);
            } else {
                // Create new jobTitle
                const createData = {
                    title: values.title,
                    description: values.description,
                    isActive: values.isActive,
                    createdByName: values.createdByName,
                    updatedByName: values.updatedByName,
                    createdAt: new Date().toISOString(),
                    updatedAt: new Date().toISOString()
                };
                await createJobTitle(createData);
            }

            await fetchJobTitles();
            resetForm();
            setSelectedJobTitle(null);
            setActiveTab(0);

            Toast.fire({
                icon: 'success',
                title: `JobTitle ${values.id ? 'updated' : 'added'} successfully`
            });
        } catch (error) {
            logger.error('Error in handleSubmit:', error);
            Toast.fire({
                icon: 'error',
                title: `Failed to ${values.id ? 'update' : 'add'} jobTitle`
            });
        } finally {
            setSubmitting(false);
        }
    };

    const handleEditClick = async (jobTitle) => {
        try {
            let jobTitleToEdit = jobTitle;
            setSelectedJobTitle(jobTitleToEdit);
            setActiveTab(1); // Switch to form tab
            window.scrollTo({ top: 0, behavior: 'smooth' });
        } catch (error) {
            Toast.fire({
                icon: 'error',
                title: 'Failed to fetch jobTitle details'
            });
        }
    };

    const handleDeleteClick = async (jobTitle) => {
        const result = await Swal.fire({
            title: 'Are you sure?',
            text: `Do you want to delete "${jobTitle.title}"? You won't be able to revert this!`,
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#d33',
            cancelButtonColor: '#3085d6',
            confirmButtonText: 'Yes, delete it!'
        });

        if (result.isConfirmed) {
            try {
                await deleteJobTitle(jobTitle.id);
                await fetchJobTitles();
                Toast.fire({
                    icon: 'success',
                    title: 'JobTitle deleted successfully'
                });
            } catch (error) {
                Toast.fire({
                    icon: 'error',
                    title: 'Failed to delete jobTitle'
                });
            }
        }
    };

    const handleToggleActive = async (jobTitle) => {
        const action = jobTitle.isActive ? 'deactivate' : 'activate';
        const result = await Swal.fire({
            title: `Are you sure?`,
            text: `Do you want to ${action} this jobTitle?`,
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: jobTitle.isActive ? '#d33' : '#28a745',
            cancelButtonColor: '#3085d6',
            confirmButtonText: `Yes, ${action} it!`
        });

        if (result.isConfirmed) {
            try {
                await updateJobTitle(jobTitle.id, {
                    ...jobTitle,
                    isActive: !jobTitle.isActive
                });
                await fetchJobTitles();
                Toast.fire({
                    icon: 'success',
                    title: `JobTitle ${action}d successfully`
                });
            } catch (error) {
                Toast.fire({
                    icon: 'error',
                    title: `Failed to ${action} jobTitle`
                });
            }
        }
    };

    const handleTabChange = (event, newValue) => {
        setActiveTab(newValue);
        if (newValue === 0) {
            setSelectedJobTitle(null);
        }
    };

    const renderJobTitleForm = () => (
        <Fade in timeout={1000}>
            <Box>
                <JobTitleForm
                    initialData={selectedJobTitle}
                    onSubmit={handleSubmit}
                    onClear={() => {
                        setSelectedJobTitle(null);
                        setActiveTab(0);
                    }}
                />
            </Box>
        </Fade>
    );

    const renderJobTitleList = () => (
        <Box sx={{ mt: 4 }}>
            <SearchSection
                searchTerm={searchTerm}
                setSearchTerm={(value) => {
                    setSearchTerm(value);
                    setPage(0);
                }}
                searchField={searchField}
                setSearchField={setSearchField}
                onClearSearch={handleClearSearch}
                loading={loading}
            />
            <Box sx={{ mb: 2 }}>
                <Typography variant="body2" color="text.secondary">
                    {searchTerm ? (
                        <>
                            Showing {filteredJobTitles.length} of {jobTitles?.length || 0} jobTitles
                            {filteredJobTitles.length > 0 && ` matching "${searchTerm}"`}
                        </>
                    ) : (
                        <>Total: {jobTitles?.length || 0} jobTitles</>
                    )}
                </Typography>
            </Box>
            {loading ? (
                <Box display="flex" justifyContent="center" alignItems="center" sx={{ mt: 4 }}>
                    <CircularProgress color="primary" />
                </Box>
            ) : (
                <Fade in timeout={1500}>
                    <StyledTableContainer component={Paper}>
                        <Table size="small" sx={tableSx(800)}>
                            <TableHead>
                                <TableRow>
                                    <TableCell>Name</TableCell>
                                    <TableCell sx={{ width: 230 }}>Description</TableCell>
                                    <TableCell sx={{ width: 126 }}>Created</TableCell>
                                    <TableCell sx={{ width: 126 }}>Updated</TableCell>
                                    <TableCell sx={{ width: 92 }}>Status</TableCell>
                                    <TableCell align="center" sx={stickyActionHeadSx}>Actions</TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {filteredJobTitles.length > 0 ? (
                                    filteredJobTitles.slice(page * rowsPerPage, (page + 1) * rowsPerPage).map((jobTitle) => (
                                        <TableRow key={jobTitle.id}>
                                            <TableCell><ClampedText>{jobTitle.title}</ClampedText></TableCell>
                                            <TableCell><ClampedText>{jobTitle.description}</ClampedText></TableCell>
                                            <TableCell><AuditCell by={jobTitle.createdByName} at={jobTitle.createdAt} /></TableCell>
                                            <TableCell><AuditCell by={jobTitle.updatedByName} at={jobTitle.updatedAt} /></TableCell>
                                            <TableCell>
                                                <ConfigurationStatusChip active={jobTitle.isActive} />
                                            </TableCell>
                                            <TableCell align="center" sx={stickyActionCellSx}>
                                                <ConfigurationActionMenu
                                                    label={jobTitle.title}
                                                    actions={[
                                                        { label: 'Edit', icon: EditIcon, onClick: () => handleEditClick(jobTitle) },
                                                        {
                                                            label: jobTitle.isActive ? 'Deactivate' : 'Activate',
                                                            icon: BlockIcon,
                                                            color: jobTitle.isActive ? '#b54708' : '#25643b',
                                                            onClick: () => handleToggleActive(jobTitle)
                                                        }
                                                    ]}
                                                />
                                            </TableCell>
                                        </TableRow>
                                    ))
                                ) : (
                                    <TableRow>
                                        <TableCell colSpan={6} align="center">
                                            {}
                                            <Box sx={{ py: 4 }}>
                                                <Typography variant="body1" color="text.secondary">
                                                    {searchTerm ? (
                                                        <>
                                                            No job titles found matching "{searchTerm}" in {searchField}
                                                            <Box sx={{ mt: 2 }}>
                                                                <Typography
                                                                    variant="body2"
                                                                    color="primary"
                                                                    sx={{ cursor: 'pointer', textDecoration: 'underline' }}
                                                                    onClick={handleClearSearch}
                                                                >
                                                                    Clear search to view all Job Titles
                                                                </Typography>
                                                            </Box>
                                                        </>
                                                    ) : (
                                                        'No jobTitles available'
                                                    )}
                                                </Typography>
                                            </Box>
                                        </TableCell>
                                    </TableRow>
                                )}
                            </TableBody>
                        </Table>

                        <ConfigurationPagination
                            page={page}
                            rowsPerPage={rowsPerPage}
                            total={filteredJobTitles.length}
                            onPageChange={setPage}
                        />
                    </StyledTableContainer>
                </Fade>
            )}
        </Box>
    );

    return (
        <Box sx={{ p: 3 }}>
            <Box sx={{ borderBottom: 1, borderColor: 'divider', mb: 3 }}>
                <Tabs
                    value={activeTab}
                    onChange={handleTabChange}
                    sx={{
                        '& .MuiTab-root': {
                            fontSize: '1rem',
                            textTransform: 'none'
                        }
                    }}
                >
                    <Tab icon={<ListIcon />} iconPosition="start" label="JobTitles List" />
                    <Tab icon={<AddIcon />} iconPosition="start" label={selectedJobTitle ? 'Edit JobTitle' : 'Add JobTitle'} />
                </Tabs>
            </Box>

            {activeTab === 0 ? renderJobTitleList() : renderJobTitleForm()}
        </Box>
    );
};

export default JobTitle;
